// extracted by mini-css-extract-plugin
export default {"answers":"Answers_answers__g9BU2","answer":"Answers_answer__OjaT7","correct":"Answers_correct__nvK7x","wrong":"Answers_wrong__ASdyr"};